import { useStore } from 'src/contexts/StoreContext';
import { EditLookupToolbarProps } from '../EditLookupToolbar.types';
import { useMemo } from 'react';
import { ProductOptionModel } from 'src/store/_models/productOption';
import { EDIT_TOOLS } from '../../base-toolbar/BaseToolbar.constants';
import { ACTIVE_TOOLS } from 'src/store/page-project/pageProject.constants';
import { AnalyticsEvents } from 'src/_shared/analyticsEvents';
import amplitude from 'src/_shared/amplitude';
import { getAvailableEditTool } from '../EditLookupToolbar.constants';
import { ProductOptionChoiceModel } from 'src/store/_models/productOptionChoice';
import { parseAnalyticsParamsByUserImageArea } from 'src/_shared/analytics.utils';

export const useFiltersToolLogic = ({ onOpenTool, onCloseTool }: EditLookupToolbarProps) => {
  const {
    project: { setActiveTool, activeUserImageArea },
  } = useStore();

  const filtersMiniatures = activeUserImageArea?.userImage?.filtersMiniatures ?? [];
  const selectedFilter = activeUserImageArea?.userImage?.filter?.toLowerCase() ?? 'original';
  const productFamily = activeUserImageArea?.product?.family ?? '';
  const productId = activeUserImageArea?.productId ?? '';

  return useMemo(() => {
    return {
      tool: ProductOptionModel.create({
        code: EDIT_TOOLS.filters,
        choices: filtersMiniatures.map(({ filter, miniatureUrl }) =>
          ProductOptionChoiceModel.create({
            productFamily,
            productOptionCode: EDIT_TOOLS.filters,
            productOptionChoiceCode: filter,
            enabled: true,
            selected: selectedFilter === filter,
            previewImageUrl: miniatureUrl,
            isCustom: false,
            productConfigurationIdsMap: {
              [productId]: filter,
            },
          }),
        ),
      }),
      onOpenTool: async tool => {
        setActiveTool(ACTIVE_TOOLS.filters);
        if (onOpenTool) await onOpenTool(tool);

        amplitude.trackEvent(
          AnalyticsEvents.modifyPhoto.filterOptionClick,
          parseAnalyticsParamsByUserImageArea(activeUserImageArea),
        );

        return { canBeSelected: true };
      },
      onSelectToolOption: async tool => {
        activeUserImageArea?.userImage?.applyFilter(tool.productOptionChoiceCode);

        amplitude.trackEvent(AnalyticsEvents.modifyPhoto.filterClick, {
          ...parseAnalyticsParamsByUserImageArea(activeUserImageArea),
          filter_choice: tool.productOptionChoiceCode,
        });
      },
      onCloseTool: async tool => {
        setActiveTool(ACTIVE_TOOLS.frame);
        if (onCloseTool) await onCloseTool(tool);
      },
      ToolOptionsRenderer: getAvailableEditTool(EDIT_TOOLS.filters)?.ToolOptionsRenderer,
    };
  }, [filtersMiniatures, selectedFilter, productFamily, productId, activeUserImageArea, onOpenTool, onCloseTool]);
};
